import { Box, Fade, SxProps, Theme, useScrollTrigger } from "@mui/material";
import { FC } from "react";

const ShowOnScroll: FC<{ window?: () => Window; children: React.ReactElement; sx?: SxProps<Theme>}> = ({
    children,
    window,
    sx
}) => {
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        target: window ? window() : undefined,
    });

    return (
        <Box sx={sx}>
            <Fade appear={false} in={trigger}>
                {children}
            </Fade>
        </Box>
    );
}

export default ShowOnScroll;